/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Link_Invalid_ProductInputs */

const vi_error_kiotviet_link_invalid_product = /** @type {(inputs: Error_Kiotviet_Link_Invalid_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm đã chọn không dùng được (đã ngừng bán hoặc không tồn tại). Chọn sản phẩm khác.`)
};

/**

* @param {Error_Kiotviet_Link_Invalid_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_link_invalid_product = /** @type {((inputs?: Error_Kiotviet_Link_Invalid_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Link_Invalid_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_link_invalid_product(inputs)
});